import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';

import {
  FlightScaleTableBaggage, FlightScaleTableDaysDifference, FlightScaleTablePointTime,
  FlightScaleTableSize, FlightScaleTableLugaggeHoverEvent
} from '@design-system/components/organisms/flight-scale-table/entities/flight-scale-table.types';
import {
  TypographyColor, TypographyFontFamily, TypographyFontSize
} from '@design-system/components/atoms/typography/entities/typography.types';
import { Icon, IconFillColor } from '@design-system/components/atoms/icon/entities/icon.types';
import { FlightScaleSize } from '@design-system/components/atoms/flight-scale/entities/flight-scale.types';
import { FlightDurationFlightTime } from '@design-system/components/molecules/flight-duration/entities/flight-duration.types';
import { IconDsComponent } from '@design-system/components/atoms/icon/icon.component';
import { TypographyDsComponent } from '@design-system/components/atoms/typography/typography.component';
import { FlightScaleDsComponent } from '@design-system/components/atoms/flight-scale/flight-scale.component';
import { ImageDsComponent } from '@design-system/components/molecules/image/image.component';
import { FlightDurationDsComponent } from '@design-system/components/molecules/flight-duration/flight-duration.component';

@Component({
  selector: 'app-ds-flight-scale-table',
  templateUrl: './flight-scale-table.component.html',
  styleUrls: ['./flight-scale-table.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    TypographyDsComponent,
    IconDsComponent,
    ImageDsComponent,
    FlightScaleDsComponent,
    FlightDurationDsComponent,
  ]
})
export class FlightScaleTableDsComponent {

  @Input() size = FlightScaleTableSize.MD;
  @Input() airlineLogo: string;
  @Input() airlineName: string;
  @Input() departurePointCode: string;
  @Input() arrivalPointCode: string;
  @Input() departureTime: FlightScaleTablePointTime;
  @Input() arrivalTime: FlightScaleTablePointTime;
  @Input() daysDifference: FlightScaleTableDaysDifference;
  @Input() baggage: FlightScaleTableBaggage;
  @Input() flightTime: FlightDurationFlightTime;
  @Input() stops: number;
  @Input() stopsLabel: string;

  @Output() clickEvent: EventEmitter<void> = new EventEmitter<void>();
  // eslint-disable-next-line max-len
  @Output() lugaggerHover: EventEmitter<FlightScaleTableLugaggeHoverEvent> = new EventEmitter<FlightScaleTableLugaggeHoverEvent>();

  public readonly xsFontSize = TypographyFontSize.XS;
  public readonly xxsFontSize = TypographyFontSize.XXS;
  public readonly xxxsFontSize = TypographyFontSize.XXXS;
  public readonly minorFontSize = TypographyFontSize.Minor;

  public readonly semiBoldFontFamily = TypographyFontFamily.SemiBold;

  public readonly primaryTextColor = TypographyColor.Primary;
  public readonly secondaryTextColor = TypographyColor.Secondary;

  public readonly backpack = Icon.Backpack;
  public readonly handLuggage = Icon.HandLuggage;
  public readonly luggage = Icon.Luggage;

  public readonly smallScale = FlightScaleSize.SM;

  constructor() { }

  get isRegular(): boolean {
    return this.size === FlightScaleTableSize.RG;
  }

  get isMedium(): boolean {
    return this.size === FlightScaleTableSize.MD;
  }

  get isSmall(): boolean {
    return this.size === FlightScaleTableSize.SM;
  }

  get isMinor(): boolean {
    return this.size === FlightScaleTableSize.Minor;
  }

  get isTiny(): boolean {
    return this.isSmall || this.isMinor;
  }

  public getIconFillColor(isIncluded: boolean): IconFillColor {
    return isIncluded ? IconFillColor.Primary : IconFillColor.Disabled;
  }

}
